import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'environments/environment';

import { BaseRequestResult, BaseService } from '@mottu-ops/global-components';
import { LoggedUserInfo } from '@mottu-ops/operation-utils';

@Injectable({
	providedIn: 'root',
})
export class MaintenanceOperationBffService {
	private _baseUrl: string = environment.operationBffUrl;

	constructor(private http: HttpClient) {}

	getLoggedUserInfo(token: string): Observable<LoggedUserInfo> {
		return this.http
			.get<BaseRequestResult<LoggedUserInfo>>(`${this._baseUrl}/user/logged-user-info`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.pipe(map(BaseService.extractResult));
	}
}
